import React from 'react';
import t from 'react-translate';
import { AngularContext } from 'react-app';

import GradientAiIcon from 'lecture_pages/components/left-panel/novo-ai/components/shared/gradient-ai-icon';
import { AIFeedbackDataRequest } from 'redux/schemas/models/submissions';
import aiInsightsPillStyles from './styles';

const AiInsightsStatusPill: React.FC = () => {
  const [isGeneratingFeedback, setIsGeneratingFeedback] = React.useState(false);
  const { injectServices } = React.useContext(AngularContext);
  const [ReportsManager] = injectServices(['ReportsManager']);

  React.useEffect(() => {
    const handleGenerating = () => setIsGeneratingFeedback(true);
    const handleUpdated = () => setIsGeneratingFeedback(false);
    window.addEventListener('ai-feedback-generating', handleGenerating);
    window.addEventListener('ai-feedback-updated', handleUpdated);
    return () => {
      window.removeEventListener('ai-feedback-generating', handleGenerating);
      window.removeEventListener('ai-feedback-updated', handleUpdated);
    };
  }, []);

  const { currentReport } = ReportsManager;
  const reportAiFeedback = currentReport?.aiFeedback;
  const feedbackDataRequest = currentReport?.feedbackDataRequest as AIFeedbackDataRequest;

  const isGenerating = feedbackDataRequest?.completed === false || isGeneratingFeedback;
  const isGenerated = feedbackDataRequest?.completed === true && !!reportAiFeedback;

  if (!isGenerating && !isGenerated) {
    return null;
  }

  const handleClick = () => {
    const section = document.getElementById('ai-insights-section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      css={aiInsightsPillStyles}
      onClick={handleClick}
      data-qa={isGenerating ? 'ai-insights-pill-generating' : 'ai-insights-pill-generated'}
      type='button'
    >
      <GradientAiIcon icon='gen-ai' size='xss-smallest' />
      <span>
        {isGenerating
          ? t.LECTURE_PAGES.COMPONENTS.AI_INSIGHTS.GENERATING()
          : t.LECTURE_PAGES.COMPONENTS.AI_INSIGHTS.GENERATED()}
      </span>
    </button>
  );
};

export default AiInsightsStatusPill;
